import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {state} from 'lit/decorators/state.js';
import {classMap} from 'lit/directives/class-map.js';
import {unzipSync, strFromU8} from 'fflate';
import {connect} from 'pwa-helpers';
import store from '../../store';

import {
	fetchProfileResult,
	setLoadedData,
	setPicoPassword,
	saveSimJson,
	saveCustomUploadStatus,
	resetCustomUpload,
	customUpload
} from '../../slices/lightProfileSlice';



@customElement('light-profile-drop')
export class LightProfileDrop extends connect(store)(LitElement) {

	static styles = [
		css`
          :host {

          }

          label {
            display: block;
 		    padding: 5px 10px;
            border: var(--border-widget);
            color: var(--color-white);
		    font-family: var(--font-family-light);
		    font-size: 12px;
		    font-style: normal;
		    font-weight: 400;
		    line-height: 19px;
          }

          .fileDropped label {
            border-color: var(--color-ok);
          }
		`
	];


	@state({type: Boolean})
	draggedOver = false;

	@state({type: Boolean})
	fileDropped = false;

	@state({type: String})
	fileName = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(s) {
		this.state = s;
		this.lightProfile = s.lightProfile.data;
		this.lang = s.status.lang;
		this.customUploadedFile = s.lightProfile.fileDropped;
		this.customFileName = s.lightProfile.fileName;
		this.fileDraggedOver = s.lightProfile.draggedOver;
	}

	// assign dragover event to element
	connectedCallback() {
		super.connectedCallback();
		this.addEventListener('dragover', this.dragover);
		this.addEventListener('dragenter', this.dragenter);
		this.addEventListener('dragleave', this.dragleave);
		this.addEventListener('drop', this.drop);
	}
	// remove dragover event from element
	disconnectedCallback() {
		super.disconnectedCallback();
		this.removeEventListener('dragover', this.dragover);
		this.removeEventListener('dragenter', this.dragenter);
		this.removeEventListener('dragleave', this.dragleave);
		this.removeEventListener('drop', this.drop);
	}
	dragover(event) {
		event.preventDefault();
		this.draggedOver = true;
	}
	dragenter(event) {
		event.preventDefault();
		this.draggedOver = true;
	}
	dragleave(event) {
		event.preventDefault();
		//this.draggedOver = false;
	}
	drop(event) {
		event.preventDefault();
		event.stopPropagation();
		this.draggedOver = false;
		const draggedData = event.dataTransfer;
		const files = draggedData.files;
		Array.from(files).forEach((file) => {
			this.fileHandler(file, file.name, file.type);
		});
	}

	fileHandler(file, name, type) {
		if (type !== 'application/zip') {
			console.log('wrong type', type);
			this.fileDropped = true;
			this.fileName = 'wrong type';
		}
		const reader = new FileReader();
		reader.readAsArrayBuffer(file);
		reader.onloadend = async () => {
			const ui8 = new Uint8Array(reader.result);
			const decompressed = unzipSync(ui8, {});
			// remove keys starting wit __ from object
			Object.keys(decompressed).forEach(key => {
				if (key.startsWith('__') || key.endsWith('/') || !key.endsWith('.json')) delete decompressed[key];
			});

			let conf9Data = null;
			let setupData = null;
			Object.keys(decompressed).forEach(key => {
				if (key.endsWith('conf9.json')) {
					conf9Data = decompressed[key];
				}
				if (key.endsWith('setup.json')) {
					setupData = decompressed[key];
				}
			});

			console.log('decompressed', decompressed);

			const conf9 = JSON.parse(strFromU8(conf9Data));
			const setup = JSON.parse(strFromU8(setupData));
			if (conf9 && setup) {
				const simJson = {
					format: 1,
					latitude: conf9.comment.project.location.latitude,
					longitude: conf9.comment.project.location.longitude,
					localtimezone: conf9.comment.project.location.timezone,
					simulation_start: '2024-01-01T11:00:00Z',
					simulation_end: '2025-01-01T11:00:00Z',
					setup: setup
				};

				store.dispatch(saveSimJson(simJson));
				store.dispatch(saveCustomUploadStatus({ status: 'custom upload'}));
				this.fileDropped = true;
				this.fileName = name;

				await store.dispatch(
					customUpload(
						{
							draggedOver: true,
							fileDropped: true,
							fileName: name,
						}
					)
				);

				await store.dispatch(
					setLoadedData(
						{
							base: conf9.comment.project.base,
							zone: conf9.comment.project.zone,
							location: conf9.comment.project.location,
							centralPowerControl: conf9.comment.project.centralPowerControl ?? 'on',
						}
					)
				);
				await store.dispatch(setPicoPassword(
					{
						password: conf9.wifi?.ap?.pass,
					}
				));

				await store.dispatch(
					fetchProfileResult(
						simJson
					)
				);
			} else {
				this.fileName = 'wrong file format';
				store.dispatch(saveCustomUploadStatus({ status: 'error', filename: 'wrong file format' }));
			}
			/*
			await store.dispatch(
				setLuminaryId(
					{
						id: json.project.luminary
					}
				)
			);
			 */
		};
	}

	render() {
		return html`
			<div class="droptarget ${classMap({draggedOver: this.fileDraggedOver, fileDropped: this.customUploadedFile })}">
				<label for="upload">${this.customUploadedFile ? this.fileName : 'Drag\'n\'Drop ZIP'}</label>
			</div>
		`;
	}
}
